import React from 'react';
import Select from 'react-select';
const options = [
    { value: 'perItem', label: 'Price per Item' },
    { value: 'perPersonExcInfant', label: 'Price per Person Exc Infant' },
    { value: 'perPersonIncInfant', label: 'Price per Person Inc Infant' },
    { value: 'perAdult', label: 'Price per Adult' },
    { value: 'perChildExcInfant', label: 'Price per Child Exc Infant' },
    { value: 'perChildIncInfant', label: 'Price per Child Inc Infant' },
    { value: 'perInfant', label: 'Price per Infant' },
    { value: 'perNight', label: 'Price per Night' },
    { value: 'perAdultPerNight', label: 'Price per Adult per Night' },
    {
        value: 'perChildExcInfantPerNight',
        label: 'Price per Child Exc Infant per Night',
    },
    {
        value: 'perChildIncInfantPerNight',
        label: 'Price per Child Inc Infant per Night',
    },
    { value: 'perInfantPerNight', label: 'Price per Infant per Night' },
    {
        value: 'perPersonExcInfantPerNight',
        label: 'Price per Person Exc Infant Per Night',
    },
    {
        value: 'perPersonIncInfantPerNight',
        label: 'Price per Person Inc Infant Per Night',
    },
];

const PricePerSelect = ({ selectedOption = null, handleChange, name, selectStyles }) => {
    const selectedOptionValue = options.find((opt) => opt.value === selectedOption);
    return (
        <div className="pkgCalc-form-select">
            <Select
                name={name}
                onChange={handleChange}
                options={options}
                value={selectedOptionValue}
                styles={selectStyles}
            />
        </div>
    );
};

export default PricePerSelect;
